// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-05-30T15:21:51.342Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const AccountListView = lazy(() => import('@/finance/AccountListView').then(m => ({ default: m.AccountListView })));
const AccountDetailView = lazy(() => import('@/finance/AccountDetailView').then(m => ({ default: m.AccountDetailView })));
const AccountDerivationRuleListView = lazy(() => import('@/finance/AccountDerivationRuleListView').then(m => ({ default: m.AccountDerivationRuleListView })));
const AccountDerivationRuleDetailView = lazy(() => import('@/finance/AccountDerivationRuleDetailView').then(m => ({ default: m.AccountDerivationRuleDetailView })));
const AccountDimensionRuleListView = lazy(() => import('@/finance/AccountDimensionRuleListView').then(m => ({ default: m.AccountDimensionRuleListView })));
const AccountDimensionRuleDetailView = lazy(() => import('@/finance/AccountDimensionRuleDetailView').then(m => ({ default: m.AccountDimensionRuleDetailView })));
const DimensionDefinitionListView = lazy(() => import('@/finance/DimensionDefinitionListView').then(m => ({ default: m.DimensionDefinitionListView })));
const DimensionDefinitionDetailView = lazy(() => import('@/finance/DimensionDefinitionDetailView').then(m => ({ default: m.DimensionDefinitionDetailView })));
const DimensionValueListView = lazy(() => import('@/finance/DimensionValueListView').then(m => ({ default: m.DimensionValueListView })));
const DimensionValueDetailView = lazy(() => import('@/finance/DimensionValueDetailView').then(m => ({ default: m.DimensionValueDetailView })));
const DistributionProfileListView = lazy(() => import('@/finance/DistributionProfileListView').then(m => ({ default: m.DistributionProfileListView })));
const DistributionProfileDetailView = lazy(() => import('@/finance/DistributionProfileDetailView').then(m => ({ default: m.DistributionProfileDetailView })));
const FiscalPeriodListView = lazy(() => import('@/finance/FiscalPeriodListView').then(m => ({ default: m.FiscalPeriodListView })));
const FiscalPeriodDetailView = lazy(() => import('@/finance/FiscalPeriodDetailView').then(m => ({ default: m.FiscalPeriodDetailView })));
const FiscalYearListView = lazy(() => import('@/finance/FiscalYearListView').then(m => ({ default: m.FiscalYearListView })));
const FiscalYearDetailView = lazy(() => import('@/finance/FiscalYearDetailView').then(m => ({ default: m.FiscalYearDetailView })));
const PlanHeaderListView = lazy(() => import('@/finance/PlanHeaderListView').then(m => ({ default: m.PlanHeaderListView })));
const PlanHeaderDetailView = lazy(() => import('@/finance/PlanHeaderDetailView').then(m => ({ default: m.PlanHeaderDetailView })));
const PlanLineListView = lazy(() => import('@/finance/PlanLineListView').then(m => ({ default: m.PlanLineListView })));
const PlanLineDetailView = lazy(() => import('@/finance/PlanLineDetailView').then(m => ({ default: m.PlanLineDetailView })));
const PlanLineReevaluationRunListView = lazy(() => import('@/finance/PlanLineReevaluationRunListView').then(m => ({ default: m.PlanLineReevaluationRunListView })));
const PlanLineReevaluationRunDetailView = lazy(() => import('@/finance/PlanLineReevaluationRunDetailView').then(m => ({ default: m.PlanLineReevaluationRunDetailView })));
const PlanScenarioListView = lazy(() => import('@/finance/PlanScenarioListView').then(m => ({ default: m.PlanScenarioListView })));
const PlanScenarioDetailView = lazy(() => import('@/finance/PlanScenarioDetailView').then(m => ({ default: m.PlanScenarioDetailView })));
const PlanStatementTemplateListView = lazy(() => import('@/finance/PlanStatementTemplateListView').then(m => ({ default: m.PlanStatementTemplateListView })));
const PlanStatementTemplateDetailView = lazy(() => import('@/finance/PlanStatementTemplateDetailView').then(m => ({ default: m.PlanStatementTemplateDetailView })));
const PlanVersionListView = lazy(() => import('@/finance/PlanVersionListView').then(m => ({ default: m.PlanVersionListView })));
const PlanVersionDetailView = lazy(() => import('@/finance/PlanVersionDetailView').then(m => ({ default: m.PlanVersionDetailView })));
const PlanVersionPublishRunListView = lazy(() => import('@/finance/PlanVersionPublishRunListView').then(m => ({ default: m.PlanVersionPublishRunListView })));
const PlanVersionPublishRunDetailView = lazy(() => import('@/finance/PlanVersionPublishRunDetailView').then(m => ({ default: m.PlanVersionPublishRunDetailView })));
const PlanViewListView = lazy(() => import('@/finance/PlanViewListView').then(m => ({ default: m.PlanViewListView })));
const PlanViewDetailView = lazy(() => import('@/finance/PlanViewDetailView').then(m => ({ default: m.PlanViewDetailView })));
const VatCodeListView = lazy(() => import('@/finance/VatCodeListView').then(m => ({ default: m.VatCodeListView })));
const VatCodeDetailView = lazy(() => import('@/finance/VatCodeDetailView').then(m => ({ default: m.VatCodeDetailView })));
const FinanceAccountGroupAdminPage = lazy(() => import('@/finance/FinanceAccountGroupAdminPage.generated').then(m => ({ default: m.default })));

/**
 * Finance Module Routes
 */
export const financeRoutes = [
{ path: '/finance/accounts',
element: <Suspense><AccountListView /></Suspense> },
{ path: '/finance/accounts/:id',
element: <Suspense><AccountDetailView /></Suspense> },
{ path: '/finance/accountderivationrules',
element: <Suspense><AccountDerivationRuleListView /></Suspense> },
{ path: '/finance/accountderivationrules/:id',
element: <Suspense><AccountDerivationRuleDetailView /></Suspense> },
{ path: '/finance/accountdimensionrules',
element: <Suspense><AccountDimensionRuleListView /></Suspense> },
{ path: '/finance/accountdimensionrules/:id',
element: <Suspense><AccountDimensionRuleDetailView /></Suspense> },
{ path: '/finance/dimensiondefinitions',
element: <Suspense><DimensionDefinitionListView /></Suspense> },
{ path: '/finance/dimensiondefinitions/:id',
element: <Suspense><DimensionDefinitionDetailView /></Suspense> },
{ path: '/finance/dimensionvalues',
element: <Suspense><DimensionValueListView /></Suspense> },
{ path: '/finance/dimensionvalues/:id',
element: <Suspense><DimensionValueDetailView /></Suspense> },
{ path: '/finance/distributionprofiles',
element: <Suspense><DistributionProfileListView /></Suspense> },
{ path: '/finance/distributionprofiles/:id',
element: <Suspense><DistributionProfileDetailView /></Suspense> },
{ path: '/finance/fiscalperiods',
element: <Suspense><FiscalPeriodListView /></Suspense> },
{ path: '/finance/fiscalperiods/:id',
element: <Suspense><FiscalPeriodDetailView /></Suspense> },
{ path: '/finance/fiscalyears',
element: <Suspense><FiscalYearListView /></Suspense> },
{ path: '/finance/fiscalyears/:id',
element: <Suspense><FiscalYearDetailView /></Suspense> },
{ path: '/finance/planheaders',
element: <Suspense><PlanHeaderListView /></Suspense> },
{ path: '/finance/planheaders/:id',
element: <Suspense><PlanHeaderDetailView /></Suspense> },
{ path: '/finance/planlines',
element: <Suspense><PlanLineListView /></Suspense> },
{ path: '/finance/planlines/:id',
element: <Suspense><PlanLineDetailView /></Suspense> },
{ path: '/finance/planlinereevaluationruns',
element: <Suspense><PlanLineReevaluationRunListView /></Suspense> },
{ path: '/finance/planlinereevaluationruns/:id',
element: <Suspense><PlanLineReevaluationRunDetailView /></Suspense> },
{ path: '/finance/planscenarios',
element: <Suspense><PlanScenarioListView /></Suspense> },
{ path: '/finance/planscenarios/:id',
element: <Suspense><PlanScenarioDetailView /></Suspense> },
{ path: '/finance/planstatementtemplates',
element: <Suspense><PlanStatementTemplateListView /></Suspense> },
{ path: '/finance/planstatementtemplates/:id',
element: <Suspense><PlanStatementTemplateDetailView /></Suspense> },
{ path: '/finance/planstatementtemplates/template/new',
element: <Suspense><PlanStatementTemplateDetailView mode="template" /></Suspense> },
{ path: '/finance/planstatementtemplates/template/:templateId',
element: <Suspense><PlanStatementTemplateDetailView mode="template" /></Suspense> },
{ path: '/finance/planversions',
element: <Suspense><PlanVersionListView /></Suspense> },
{ path: '/finance/planversions/:id',
element: <Suspense><PlanVersionDetailView /></Suspense> },
{ path: '/finance/planversionpublishruns',
element: <Suspense><PlanVersionPublishRunListView /></Suspense> },
{ path: '/finance/planversionpublishruns/:id',
element: <Suspense><PlanVersionPublishRunDetailView /></Suspense> },
{ path: '/finance/planviews',
element: <Suspense><PlanViewListView /></Suspense> },
{ path: '/finance/planviews/:id',
element: <Suspense><PlanViewDetailView /></Suspense> },
{ path: '/finance/planviews/template/new',
element: <Suspense><PlanViewDetailView mode="template" /></Suspense> },
{ path: '/finance/planviews/template/:templateId',
element: <Suspense><PlanViewDetailView mode="template" /></Suspense> },
{ path: '/finance/vatcodes',
element: <Suspense><VatCodeListView /></Suspense> },
{ path: '/finance/vatcodes/:id',
element: <Suspense><VatCodeDetailView /></Suspense> },
{ path: '/finance/financeaccountgroups', element: <Suspense><FinanceAccountGroupAdminPage /></Suspense> }
];
